/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelBgVideo64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelBgVideo64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M10 18C10 15.7909 11.7909 14 14 14H50C52.2091 14 54 15.7909 54 18V46C54 48.2091 52.2091 50 50 50H14C11.7909 50 10 48.2091 10 46V18Z"
            fill="currentColor"
          />
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.7725 25.0808C28.6188 24.9809 28.4227 24.9731 28.2615 25.0605C28.1004 25.148 28 25.3166 28 25.5V38.5C28 38.6834 28.1004 38.852 28.2615 38.9395C28.4227 39.0269 28.6188 39.0191 28.7725 38.9192L38.7725 32.4192C38.9144 32.327 39 32.1692 39 32C39 31.8308 38.9144 31.673 38.7725 31.5808L28.7725 25.0808ZM29 37.5787V26.4213L37.5826 32L29 37.5787Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 18C10 15.7909 11.7909 14 14 14H50C52.2091 14 54 15.7909 54 18V46C54 48.2091 52.2091 50 50 50H14C11.7909 50 10 48.2091 10 46V18ZM14 15H50C51.6569 15 53 16.3431 53 18V46C53 47.6569 51.6569 49 50 49H14C12.3431 49 11 47.6569 11 46V18C11 16.3431 12.3431 15 14 15Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelBgVideo64Icon.tags = ['video', 'play', 'media', 'film', 'cinema'];

AddPanelBgVideo64Icon.category = '64x64 (Add panel)';

AddPanelBgVideo64Icon.iconSize = 64;
